<header class="header-sticky">
  <app-top-bar></app-top-bar>
</header>
<div class="box-cotizar mx-auto mt-5" >

	<mat-spinner *ngIf="cotizacion.cargando" diameter="20" class="mx-auto mt-2"></mat-spinner>
	
	<div *ngIf="!cotizacion.cargando">
		<div class="overflow-auto">
			<!-- <app-productos-carrito></app-productos-carrito> -->
		</div>
		
		<form [formGroup]="form" *ngIf="globals.configuracion.front.cart.productos.length > 0" class="box-form mx-auto my-5 px-2" (submit)="guardarCotizacion()">
			<!-- <div *ngIf="globals.configuracion.front.cart.cotizacion_id == '' && globals.configuracion.front.usuario.cotizacion_cliente_id == ''"> -->
			<div>
				<mat-form-field appearance="standard" class="w-100">
					<mat-label>Nombre</mat-label>
					<input type="text" matInput formControlName="nombre">
					<mat-error *ngIf="form.controls.nombre.touched && form.controls.nombre.invalid && form.controls.nombre.errors.required">Ingrese su nombre</mat-error>
				</mat-form-field>
				<div class="d-flex">
					<mat-form-field style="width: 100px;">
						<span matPrefix><mat-icon>phone</mat-icon>&nbsp;</span>
						<mat-label>Tel</mat-label>
						<mat-select formControlName="telefono_prefijo">
							<mat-option value="412">412</mat-option>
							<mat-option value="414">414</mat-option>
							<mat-option value="416">416</mat-option>
							<mat-option value="424">424</mat-option>
							<mat-option value="426">426</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field floatLabel="never" class="flex-grow-1">
						<input type="tel" formControlName="telefono_numero" maxlength="7" matInput placeholder="555 55 55">
					</mat-form-field>
				</div>
				<mat-error style="font-size: 0.82rem;margin-top: -12px;" *ngIf="(form.controls.telefono_numero.touched) && (form.controls.telefono_prefijo.invalid || form.controls.telefono_numero.invalid) && ( (form.controls.telefono_prefijo.errors && form.controls.telefono_prefijo.errors.required) || (form.controls.telefono_numero.errors && form.controls.telefono_numero.errors.required) )">Ingrese su teléfono</mat-error>
				<mat-error style="font-size: 0.82rem;margin-top: -12px;" *ngIf="(form.controls.telefono_numero.touched) && (form.controls.telefono_numero.invalid) && ( (form.controls.telefono_numero.errors && form.controls.telefono_numero.errors.pattern) )">Debe contener 7 números</mat-error>
			</div>

			<mat-spinner *ngIf="formComportamiento.enviando" diameter="20" class="mx-auto mt-2"></mat-spinner>
			<button type="submit" style="background-color:#22b14d;color:white;" mat-raised-button color="primary" *ngIf="globals.configuracion.front.cart.cotizacion_id == ''" class="d-block mx-auto mt-2" [disabled]="!form.valid || formComportamiento.enviando">Confirmar pedido</button>
			<div class="container" >

				
				<button type="submit" mat-raised-button color="primary" *ngIf="globals.configuracion.front.cart.cotizacion_id != ''" class="d-block mx-auto mt-2" [disabled]="!form.valid || formComportamiento.enviando">Confirmar pedido</button>
				
				<button type="button" mat-raised-button color="accent" class="mt-2 mejor_letra "  routerLink="/catalogo">Agregar productos</button>
				<button type="button" mat-raised-button color="accent" class="mt-2 mejor_letra " style="margin-left:10px" [disabled]="formComportamiento.enviando" (click)="cancelarCotizacion()">Cancelar Cotización</button>
			</div>
		</form>
	</div>
</div>
